import { useGalleryStore } from '@stores/useGalleryStore';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import Vue3TouchEvents from 'vue3-touch-events';
import PageDetailsGallery from './page-details/PageDetailsGallery.vue';

export const initGallery = () => {
  const galleryAppDiv = document.getElementById('app-gallery');

  if (galleryAppDiv) {
    const pinia = createPinia();

    createApp(PageDetailsGallery)
      .use(Vue3TouchEvents)
      .use(pinia)
      .mount(galleryAppDiv);

    const showPhotosButton = document.querySelector('.gallery-show-button');

    const galleryStore = useGalleryStore(pinia);

    document.querySelectorAll('.gallery-mosaic__cover, .gallery-mosaic__list__item, .gallery-carousel__picture, .gallery-mosaic__action--show-photos').forEach((element) => {
      element.addEventListener('click', (event) => {
        const mediaIndex = event.currentTarget.getAttribute('data-index');
        galleryStore.setCurrentIndex(mediaIndex ? parseInt(mediaIndex, 10) : 0);
        showPhotosButton.click();
      });
    });
  }
};
